<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="video-container english" v-if="videoUrl">
    <!-- :poster="videoPosterUrl" -->
    <video
      controls
      disablePictureInPicture
      controlslist="nodownload"
      preload="metadata"
      :poster="posterUrl"
      class="fullWidthAutoHeight"
      id="videoclip"
      oncontextmenu="return false;"
      crossorigin="anonymous"
      key="videoplayer"
    >
      <source id="mp4video" :src="videoUrl" type="video/mp4" />
      <!-- <track
        v-if="closedCaptionUrl"
        id="vttvideoEN"
        kind="subtitles"
        :srclang="getLocale"
        :src="closedCaptionUrl"
        default
        crossorigin="anonymous"
      /> -->
      Your browser does not support HTML5 video.
    </video>
    <!-- <div class="controls">
      <button @click="play()" title="Play/Pause">
        <v-icon class="play_arrow" aria-label="Play">
          play_arrow
        </v-icon>
        <v-icon class="pause" aria-label="Pause">
          pause
        </v-icon>
      </button>
      <button @click="audio()" title="Mute/Unmute">
        <v-icon class="volume_off" aria-label="Mute">
          volume_off
        </v-icon>
        <v-icon class="volume_up" aria-label="Unmute">
          volume_up
        </v-icon>
      </button>
      <button @click="rewind()" title="Rewind">
        <v-icon class="fast_rewind" aria-label="Rewind">
          fast_rewind
        </v-icon>
      </button>
      <div class="timeline">
        <div class="bar">
          <div class="inner" />
        </div>
      </div>
      <button @click="forward()" title="Fast Forward">
        <v-icon class="fast_forward" aria-label="Fast Forward">
          fast_forward
        </v-icon>
      </button>
      <button @click="captionOn()" title="Closed Caption">
        <v-icon class="closed_caption" aria-label="Closed Caption">
          closed_caption
        </v-icon>
      </button>
      <button @click="captionOff()" title="Closed Caption">
        <v-icon class="closed_caption_off" aria-label="Closed Caption">
          closed_caption_off
        </v-icon>
      </button>
      <button @click="fullScreen()" title="Fullscreen">
        <v-icon class="fullscreen">
          fullscreen
        </v-icon>
      </button>
    </div> -->
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapState } from 'pinia';

const componentOptions: ComponentOptions = {
  name: 'VideoPlayer',
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    closedCaptionUrl: {
      type: String,
      required: true,
    },
    posterUrl: {
      type: String,
      required: true,
    },
    controls: { type: Boolean, required: false, default: false },
    loop: { type: Boolean, required: false, default: false },
    width: { type: Number, required: false, default: 500 },
    height: { type: Number, required: false, default: 281 },
    autoplay: { type: Boolean, required: false, default: false },
    muted: { type: Boolean, required: false, default: false },
    poster: { type: String, required: false, default: '' },
    preload: { type: String, required: false, default: 'auto' },
  },
  data: () => ({
    video: {},
  }),
  computed: {
    ...mapState(useGlobalStore, {
      currentLocale: 'getLocale',
    }),
    getLocale() {
      return this.currentLocale === 'fr_CA' ? 'fr' : 'en';
    },
  },
  watch: {
    async language() {
      // await this.init();
    },
    videoUrl() {
      const vc = document.getElementById('videoclip');
      if (vc) {
        vc.setAttribute('src', this.videoUrl);
      }
    },
    closedCaptionUrl() {
      const vc = document.getElementById('videoclip') as HTMLVideoElement | null;
      if (vc) {
        vc.innerHTML = `<track label="English Captions" srclang="en" kind="captions" src="${this.closedCaptionUrl}" type="text/vtt" default />`;
        const tracks = vc.textTracks[0];
        tracks.mode = 'showing';
        // const video = document.querySelector('videoclip');
        // const track = video.addTextTrack('captions', 'Captions', 'en');
        // track.addCue(this.closedCaptionUrl);
        // track.mode = 'showing';
      }
    },
  },
  methods: {
    // handleVideoError(e: unknown) {
    //   // eslint-disable-next-line no-console
    //   console.error('\nVIDEO PLAYER: Error occurred:', e);
    // },
    init() {
      try {
        // Select the HTML5 video
        this.video = window.document.getElementById('videoclip');
        this.video.crossOrigin = 'anonymous';
        this.video.src = this.videoUrl;
        const videoPause: HTMLMediaElement | null =
          window.document.querySelector('.english .pause');
        const videoVolumeOff: HTMLMediaElement | null =
          window.document.querySelector('.english .volume_off');
        // set the pause button to display:none by default
        if (videoPause?.style) videoPause.style.display = 'none';
        if (videoVolumeOff?.style) videoVolumeOff.style.display = 'none';

        // update the progress bar
        this.video.addEventListener('timeupdate', () => {
          const curr = (this.video.currentTime / this.video.duration) * 100;
          const videoPlayArrow: HTMLMediaElement | null =
            window.document.querySelector('.english .play_arrow');
          const videoPlayCircle: HTMLMediaElement | null = window.document.querySelector(
            '.english .play_circle_outline'
          );
          const videoInner: HTMLMediaElement | null =
            window.document.querySelector('.english .inner');
          if (this.video.ended) {
            if (videoPlayArrow?.style) videoPlayArrow.style.display = 'block';
            if (videoPause?.style) videoPause.style.display = 'none';
          } else if (this.video.currentTime > 0 && !this.video.paused && !this.video.ended) {
            if (videoPlayArrow?.style) videoPlayArrow.style.display = 'none';
            if (videoPause?.style) videoPause.style.display = 'block';
            // window.document.querySelector(".french .bi-play-btn").style.display = "none"
            if (videoPlayCircle?.style) videoPlayCircle.style.display = 'none';
          }
          if (videoInner?.style) videoInner.style.width = `${curr}%`;
        });
      } catch (_e) {
        // eslint-disable-next-line no-console
        console.error('\nVIDEO PLAYER init: Error occurred:', _e);
      }
    },
    async play() {
      const video = this.document.getElementById('videoclip');
      // Condition when to play a video
      if (video.paused) {
        this.document.querySelector('.english .play_arrow').style.display = 'none';
        this.document.querySelector('.english .pause').style.display = 'block';
        // this.document.querySelector(".english .bi-play-btn").style.display = "none"
        this.document.querySelector('.english .play_circle_outline').style.display = 'none';
        try {
          this.document.getElementById('videoclip').play();
          const vc = document.getElementById('videoclip') as HTMLVideoElement | undefined;
          if (vc) {
            await vc.play();
          }
        } catch (_error) {
          /* empty */
        }
      } else {
        this.document.querySelector('.english .play_arrow').style.display = 'block';
        this.document.querySelector('.english .pause').style.display = 'none';
        video.pause();
      }
    },
    stopVideo() {
      this.document.querySelector('.english .play_arrow').style.display = 'block';
      this.document.querySelector('.english .pause').style.display = 'none';
      this.video.pause();
    },
    fullScreen(e: Event) {
      e.preventDefault();
      this.video.requestFullscreen();
    },
    // updateVolume() {
    //   if (this.video.muted) {
    //     this.video.muted = false;
    //   }
    //   this.video.volume = this.volume.value;
    // },
    // updateVolumeIcon updates the volume icon so that it correctly reflects
    // the volume of the video
    // updateVolumeIcon() {
    //   volumeIcons.forEach((icon) => {
    //     icon.classList.add('hidden');
    //   });

    //   volumeButton.setAttribute('data-title', 'Mute (m)');

    //   if (video.muted || video.volume === 0) {
    //     volumeMute.classList.remove('hidden');
    //     volumeButton.setAttribute('data-title', 'Unmute (m)');
    //   } else if (video.volume > 0 && video.volume <= 0.5) {
    //     volumeLow.classList.remove('hidden');
    //   } else {
    //     volumeHigh.classList.remove('hidden');
    //   }
    // },
    // toggleMute mutes or unmutes the video when executed
    // When the video is unmuted, the volume is returned to the value
    // it was set to before the video was muted
    // toggleMute() {
    //   this.video.muted = !this.video.muted;

    //   if (this.video.muted) {
    //     volume.setAttribute('data-volume', volume.value);
    //     volume.value = 0;
    //   } else {
    //     volume.value = volume.dataset.volume;
    //   }
    // },
    // mute volume
    audio() {
      this.video.muted = !this.video.muted;

      if (this.video.muted) {
        this.document.querySelector('.volume-up').style.display = 'none';
        this.document.querySelector('.volume_off').style.display = 'block';
        // this.volume.value = 0;
      } else {
        this.document.querySelector('.volume-up').style.display = 'block';
        this.document.querySelector('.volume_off').style.display = 'none';
        // this.volume.value = this.volume.dataset.volume;
      }
    },
    // rewind the current time
    rewind() {
      this.video.currentTime -= (this.video.duration / 100) * 5;
    },
    // forward the current time
    forward() {
      this.video.currentTime += (this.video.duration / 100) * 5;
    },
    // display captions
    captionOn() {
      this.video.textTracks[0].mode = 'showing';
    },
    captionOff() {
      this.video.textTracks[0].mode = 'disabled';
    },
  },
  mounted() {
    try {
      // await this.init();
      // this.src = 'https://video.primericaonline.com/u/pfn/vod/21087_How_Money_Works_New_Film_v2.mp4';
      // const video = this.document.querySelector('#videoclip');
      // video.textTracks[0].mode = 'showing';
      // this.videoUrl;
      // const video: HTMLMediaElement | null = window.document.querySelector('#videoclip');
      // if (video?.textTracks) video.textTracks[0].mode = 'showing';
    } catch (_e) {
      // eslint-disable-next-line no-console
      console.error('\nVIDEO PLAYER: Error occurred:', _e);
    }
  },
  errorCaptured(err, vm, info) {
    // eslint-disable-next-line no-console
    console.error('\nVIDEO PLAYER: Error captured:', err, vm, info);
    return false;
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.fullWidthAutoHeight {
  width: 100%;
  height: auto;
}
video {
  background: #000;
}
.video-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4em !important;
}
.video-container .play-btn,
.video-container .play_circle_outline {
  position: absolute;
  height: auto;
  top: calc(50% - 2.5vw);
  padding: 0 0.5em;
  width: 25%;
  display: flex;
  justify-content: space-around;
  opacity: 1;
  transition: opacity 0.4s;
  z-index: 9997;
  color: #cc3333;
  font-size: 5vw !important;
}
.video-container .controls {
  position: absolute;
  background: #044c7f;
  height: 2em;
  bottom: 0em;
  padding: 0 0.5em;
  width: 100%;
  display: flex;
  justify-content: space-around;
  opacity: 0.05;
  transition: opacity 0.4s;
}
.video-container:hover .controls {
  opacity: 1;
}
.video-container .controls button {
  background: transparent;
  color: #fff;
  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);
  border: none;
  cursor: pointer;
  padding-bottom: 2px;
}
.video-container .controls .timeline {
  flex: 1;
  display: flex;
  align-items: center;
  border: none;
}
.video-container .controls .timeline .bar {
  background: rgba(1, 1, 65, 0.5);
  height: 4px;
  flex: 1;
}
.video-container .controls .timeline .bar .inner {
  background: #ccc;
  width: 0%;
  height: 100%;
}
@media (max-width: 575px) {
  .video-container .play-arrow,
  .video-container .play_circle_outline {
    top: calc(50% - 5vw);
    font-size: 10vw !important;
  }
}
</style>
